import React from 'react';
import { useIntl } from 'react-intl';

import Breadcrumbs from 'src/enosikit/components/Breadcrumbs';
import Heading from 'src/enosikit/components/Heading';

/**
 * Placeholder component that displays a loading skeleton for the TradeRuleCustomerProposals page.
 * Renders real breadcrumb and heading text, with shimmer skeletons for async card content.
 * @returns {React.ReactElement} - Placeholder component
 */
function Placeholder() {
  const intl = useIntl();

  const tradeRulesLabel = intl.formatMessage({ id: 'trade_rule.trade_rule_customer_proposals.breadcrumbs.trade_rules.label', defaultMessage: 'Trade Rules' });
  const proposalsLabel = intl.formatMessage({ id: 'trade_rule.trade_rule_customer_proposals.breadcrumbs.proposals.label', defaultMessage: 'Proposals' });
  const headingTradeRulesLabel = intl.formatMessage({ id: 'trade_rule.trade_rule_customer_proposals.heading.alias.trade_rules.label', defaultMessage: 'Trade Rules' });
  const headingProposalsLabel = intl.formatMessage({ id: 'trade_rule.trade_rule_customer_proposals.heading.context.proposals.label', defaultMessage: 'Proposals' });
  const proposedTradesTitle = intl.formatMessage({ id: 'trade_rule.trade_rule_customer_proposals.proposed_trades.title', defaultMessage: 'Proposed Trades' });

  return (
    <>
      <Breadcrumbs
        breadcrumbs={[
          { name: tradeRulesLabel, path: '/trade-rules' },
          { name: proposalsLabel },
        ]}
      />
      <Heading
        title={headingTradeRulesLabel}
        context={headingProposalsLabel}
      />

      {/* Main proposals card placeholder */}
      <div className="mt-4 mb-4 card trade-proposals">
        <div className="card-body">
          <h2>{proposedTradesTitle}</h2>

          <div className="row">
            {/* Buying column */}
            <div className="col-12 col-md-6">
              <div className="mb-3">
                <span className="placeholder placeholder-glow bg-darken" style={{ width: '80px', height: '20px' }} />
              </div>
              <div className="mb-4">
                <span className="placeholder placeholder-glow bg-darken col-10" />
              </div>

              {/* Proposal card skeleton */}
              <div className="mt-4 mb-4 card">
                <div className="card-body">
                  <div className="mb-2">
                    <span className="placeholder placeholder-glow bg-darken col-9" style={{ height: '18px' }} />
                  </div>
                  <div className="mb-3">
                    <span className="placeholder placeholder-glow bg-darken col-5" />
                  </div>
                  <div className="mb-2">
                    <span className="placeholder placeholder-glow bg-darken col-12" />
                  </div>
                  <div className="mb-2">
                    <span className="placeholder placeholder-glow bg-darken col-10" />
                  </div>
                  <div className="mb-2">
                    <span className="placeholder placeholder-glow bg-darken col-8" />
                  </div>
                  <div>
                    <span className="placeholder placeholder-glow bg-darken" style={{ width: '120px', height: '22px' }} />
                  </div>
                </div>
                <div className="card-footer">
                  <span className="placeholder placeholder-glow bg-darken" style={{ width: '100px', height: '32px' }} />
                </div>
              </div>
            </div>

            {/* Selling column */}
            <div className="col-12 col-md-6">
              <div className="mb-3">
                <span className="placeholder placeholder-glow bg-darken" style={{ width: '80px', height: '20px' }} />
              </div>
              <div className="mb-4">
                <span className="placeholder placeholder-glow bg-darken col-10" />
              </div>

              {/* Proposal card skeleton */}
              <div className="mt-4 mb-4 card">
                <div className="card-body">
                  <div className="mb-2">
                    <span className="placeholder placeholder-glow bg-darken col-9" style={{ height: '18px' }} />
                  </div>
                  <div className="mb-3">
                    <span className="placeholder placeholder-glow bg-darken col-5" />
                  </div>
                  <div className="mb-2">
                    <span className="placeholder placeholder-glow bg-darken col-12" />
                  </div>
                  <div className="mb-2">
                    <span className="placeholder placeholder-glow bg-darken col-10" />
                  </div>
                  <div className="mb-2">
                    <span className="placeholder placeholder-glow bg-darken col-8" />
                  </div>
                  <div>
                    <span className="placeholder placeholder-glow bg-darken" style={{ width: '120px', height: '22px' }} />
                  </div>
                </div>
                <div className="card-footer">
                  <span className="placeholder placeholder-glow bg-darken" style={{ width: '100px', height: '32px' }} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Placeholder;
